// extracted by mini-css-extract-plugin
module.exports = {"menu":"menu-module--menu--27dsJ","menu__item":"menu-module--menu__item--1ABAf","menu__item_active":"menu-module--menu__item_active--23qKQ"};